"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetNameCountInCompany = exports.useGetCompanyIdToUserNameCountMap = exports.useCompanyIdToNameMap = exports.getProjectMemberDisplayName = exports.getProjectMemberCompanyDisplayName = void 0;
var _react = require("react");
var _lodash = require("lodash");
var _sdk = require("../../../sdk");
const SYSTEM_CREATED_BY_DISPLAY = "Autodesk";
const NO_COMPANY_ID = "NO_COMPANY_ID";
const getNameCountInCompany = _ref => {
  let {
    userName,
    userCompanyId,
    companyIdToUserNameCountMap
  } = _ref;
  const companyId = userCompanyId || NO_COMPANY_ID;
  return !!companyIdToUserNameCountMap[companyId] && companyIdToUserNameCountMap[companyId][userName] ? companyIdToUserNameCountMap[companyId][userName] : 0;
};
const getProjectMemberDisplayName = _ref2 => {
  let {
    usersEntitiesMap,
    rolesEntitiesMap,
    companiesEntitiesMap,
    companyIdToUserNameCountMap,
    id,
    T
  } = _ref2;
  if (!id) {
    return null;
  }
  if (id === "System") {
    return SYSTEM_CREATED_BY_DISPLAY;
  }
  const projectMember = usersEntitiesMap[id] || rolesEntitiesMap[id] || companiesEntitiesMap[id];
  const user = usersEntitiesMap[id];
  if (!projectMember && id) {
    return T.translate("removedMember");
  }
  return projectMember ? "".concat(projectMember.name || (user === null || user === void 0 ? void 0 : user.email)).concat(!!user && companyIdToUserNameCountMap && getNameCountInCompany({
    userName: user.name,
    userCompanyId: user.companyId,
    companyIdToUserNameCountMap
  }) > 1 ? " - ".concat(user.email) : "") : null;
};
exports.getProjectMemberDisplayName = getProjectMemberDisplayName;
const getProjectMemberCompanyDisplayName = _ref3 => {
  let {
    usersEntitiesMap,
    companiesEntitiesMap,
    assignedToType,
    id
  } = _ref3;
  if (!id || !assignedToType) {
    return null;
  }
  switch (assignedToType) {
    case _sdk.ProjectMemberType.User:
      const companyId = (0, _lodash.get)(usersEntitiesMap[id], "companyId");
      const company = Object.values(companiesEntitiesMap).find(company => company.id === companyId);
      return company ? company.name : null;
    case _sdk.ProjectMemberType.Company:
      return (0, _lodash.get)(companiesEntitiesMap[id], "name");
    default:
      return null;
  }
};
exports.getProjectMemberCompanyDisplayName = getProjectMemberCompanyDisplayName;
const useGetCompanyIdToUserNameCountMap = users => (0, _react.useMemo)(() => users.reduce((map, user) => {
  const companyId = user.companyId || NO_COMPANY_ID;
  const userName = user.name;
  if (!map[companyId]) {
    map[companyId] = {};
  }
  if (!map[companyId][userName]) {
    map[companyId][userName] = 1;
  } else {
    map[companyId][userName] += 1;
  }
  return map;
}, {}), [users]);
exports.useGetCompanyIdToUserNameCountMap = useGetCompanyIdToUserNameCountMap;
const useGetNameCountInCompany = users => {
  const companyIdToUserNameCountMap = useGetCompanyIdToUserNameCountMap(users);
  return _ref4 => {
    let {
      userName,
      userCompanyId
    } = _ref4;
    return getNameCountInCompany({
      userName,
      userCompanyId,
      companyIdToUserNameCountMap
    });
  };
};
exports.useGetNameCountInCompany = useGetNameCountInCompany;
const useCompanyIdToNameMap = companies => (0, _react.useMemo)(() => companies.reduce((map, company) => {
  map[company.id] = company.name;
  return map;
}, {}), [companies]);
exports.useCompanyIdToNameMap = useCompanyIdToNameMap;
//# sourceMappingURL=oxygenUtils.js.map